// extracted by mini-css-extract-plugin
module.exports = {"bodyTitle":"NolBottomSheet_bodyTitle__19XcR","bodyDescription":"NolBottomSheet_bodyDescription__3KRYJ","bodyContainer":"NolBottomSheet_bodyContainer__377-w"};